<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowHearingAidUnitsPerPatient',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'net_units_sold', throughMonth),
          this.getYtdByField(yearObj, 'number_patients_purchased', throughMonth),
        );
      },
    },
  };
</script>
